import React, { Component } from "react";
import { getAllowedSwitches } from "../../../../AssetTypeConfig/Reports/SwitchinspectionReport";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { NOPB_SwitchInspectionReportSchema } from "./NOPB_SwitchInspectionReportSchema";
import { NOPB_SwitchInspectionReportSchemaV1 } from "./NOPB_SwitchInspectionReportSchemaV1";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportInfoSection from "../../../../libraries/ReportGenerator/ReportInfoSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { dataFormatters } from "../../../../utils/dataFormatters";
import { SignatureImage } from "../../utils/SignatureImage";
import reportByVersion from "../../utils/reportVersions";

export const NOPB_SwitchInspectionReportView = (props) => {
  let { reportData, signatureImage } = props;
  let rowsData = reportData && reportData.assets && Array.isArray(reportData.assets) ? reportData.assets : [];

  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection title="NEW ORLEANS PUBLIC BELT SWITCH INSPECTION REPORT" {...props} centerTitle={true} />
      <ReportInfoSection
        rows={[
          {
            col1: {
              title: "Location",
              value: reportData.location,
            },
            col2: {
              title: "Date",
              value: dataFormatters.dateFormatter(reportData.date),
            },
          },
          {
            col1: {
              title: "Track Inspector",
              value: reportData.user.name,
            },
            col2: {
              title: "Signature",
              value: <SignatureImage placement={"tableCell"} signatureImage={signatureImage} />,
            },
          },
        ]}
      />

      <span className="spacer"></span>
      <table className="table-bordered">
        {NOPB_SwitchInspectionReportSchema.sections.map((section) => {
          return <ReportTableSectionRenderer section={section} rowsData={rowsData} />;
        })}
      </table>
    </div>
  );
};

export const NOPB_SwitchInspectionReportViewV1 = (props) => {
  let { reportData, signatureImage } = props;
  let rowsData = reportData && reportData.assets && Array.isArray(reportData.assets) ? reportData.assets : [];

  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection title="NEW ORLEANS PUBLIC BELT SWITCH INSPECTION REPORT" {...props} centerTitle={true} />
      <ReportInfoSection
        rows={[
          {
            col1: {
              title: "Location",
              value: reportData.location,
            },
            col2: {
              title: "Date",
              value: dataFormatters.dateFormatter(reportData.date),
            },
          },
          {
            col1: {
              title: "Track Inspector",
              value: reportData.user.name,
            },
            col2: {
              title: "Signature",
              value: <SignatureImage placement={"tableCell"} signatureImage={signatureImage} />,
            },
          },
        ]}
      />

      <span className="spacer"></span>
      <table className="table-bordered">
        {NOPB_SwitchInspectionReportSchemaV1.sections.map((section) => {
          return <ReportTableSectionRenderer section={section} rowsData={rowsData} />;
        })}
      </table>
    </div>
  );
};

const NOPB_SwitchInspectionReport = (props) => {
  const { inspec } = props;
  let assetsArr = [];
  assetsArr.push(ReportGeneratorUtils.getInspectionAssetsWithForm(inspec, getAllowedSwitches, "nopbSwitchForm"));
  let reportVersion = ReportGeneratorUtils.getInspectionAppFormReportVersion(inspec, "nopbSwitchForm");
  const ReportView = reportByVersion(reportVersion, "nopbSwitchInspectionReport");
  return assetsArr.map((asset) =>
    asset && asset.length > 0 ? (
      <ReportView
        {...props}
        reportData={{
          assets: asset,
          location: ReportGeneratorUtils.getInspectionLocation(inspec),
          date: ReportGeneratorUtils.getInspectionDate(inspec),
          user: ReportGeneratorUtils.getInspectionUser(inspec),
        }}
      />
    ) : null,
  );
};

export default NOPB_SwitchInspectionReport;



// WEBPACK FOOTER //
// ./src/components/Reports/NOPB/SwitchInspectionReport/index.jsx